<div class="modal-content">
  <div class="modal__content">
    <div class="modal__header">
      <h3 class="h3 modal__title">
        {{ 'sharedModule.bkgVehicleDialog.addVehicle' | translate }}
      </h3>
      <button
        (click)="onClickClose()"
        type="button"
        class="modal__close"
        data-bs-dismiss="modal"
        attr.aria-label="{{ 'common.close' | translate }}"
      >
        <img src="assets/images/icons/close.svg" alt="" />
      </button>
    </div>
    <div class="modal__body">
      <form [formGroup]="requestedDataForm">
        <div class="form-group">
          <label class="text-start">
            {{
              'sharedModule.bkgVehicleDialogCompleteCarDataForm.kilometers'
                | translate
            }}
          </label>
          <input
            numberDots
            step="1000"
            formControlName="km"
            placeholder="{{
              'sharedModule.bkgVehicleDialogCompleteCarDataForm.kilometers'
                | translate
            }}"
          />
        </div>
        <button
          class="btn-primary btn-large is-block"
          [disabled]="checkDisabled"
          (click)="submitData()"
        >
          {{
            'sharedModule.bkgVehicleDialogCompleteCarDataForm.agree' | translate
          }}
        </button>
      </form>
    </div>
  </div>
</div>
